import React, { useState, useEffect } from 'react';
import Layout from '../../components/ui/Layout';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import SubHeader from '../../components/ui/SubHeader';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';

import UserManagementGrid from './components/UserManagementGrid';
import RolePermissionMatrix from './components/RolePermissionMatrix';
import SystemConfigurationPanel from './components/SystemConfigurationPanel';
import AuditTrailViewer from './components/AuditTrailViewer';
import SecurityMonitoringDashboard from './components/SecurityMonitoringDashboard';
import BackupManagementPanel from './components/BackupManagementPanel';
import PerformanceMonitoringPanel from './components/PerformanceMonitoringPanel';
import UserEditModal from './components/UserEditModal';
import UserApprovalPanel from './components/UserApprovalPanel';


const SystemAdministrationAndUserManagement = () => {
  const { userProfile } = useAuth();
  const [activeTab, setActiveTab] = useState('users');
  const [currentUser] = useState({
    role: 'admin',
    name: 'أحمد محمد العلي'
  });
  const [showUserModal, setShowUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Add this handler for quick menu toggle
  const handleQuickMenuToggle = () => {
    console.log('Quick menu toggled');
  };

  // Action boxes for system administration
  const adminActions = [
  {
    id: 'approvals',
    icon: 'UserCheck',
    label: 'موافقات المستخدمين',
    color: '#FBBF24',
    bgGradient: 'linear-gradient(135deg, rgba(251, 191, 36, 0.2) 0%, rgba(252, 211, 77, 0.25) 100%)',
    borderColor: 'rgba(251, 191, 36, 0.5)',
    onClick: () => setActiveTab('approvals')
  },
  {
    id: 'users',
    icon: 'Users',
    label: 'إدارة المستخدمين',
    color: '#3B82F6',
    bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
    borderColor: 'rgba(59, 130, 246, 0.5)',
    onClick: () => setActiveTab('users')
  },
  {
    id: 'permissions',
    icon: 'Shield',
    label: 'الصلاحيات',
    color: '#10B981',
    bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
    borderColor: 'rgba(16, 185, 129, 0.5)',
    onClick: () => setActiveTab('permissions')
  },
  {
    id: 'config',
    icon: 'Settings',
    label: 'إعدادات النظام',
    color: '#F59E0B',
    bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
    borderColor: 'rgba(245, 158, 11, 0.5)',
    onClick: () => setActiveTab('config')
  },
  {
    id: 'branding',
    icon: 'Building2',
    label: 'العلامة التجارية',
    color: '#06B6D4',
    bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
    borderColor: 'rgba(6, 182, 212, 0.5)',
    onClick: () => setActiveTab('config')
  },
  {
    id: 'security',
    icon: 'Lock',
    label: 'المراقبة الأمنية',
    color: '#EF4444',
    bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(248, 113, 113, 0.25) 100%)',
    borderColor: 'rgba(239, 68, 68, 0.5)',
    onClick: () => setActiveTab('security')
  },
  {
    id: 'audit',
    icon: 'FileText',
    label: 'سجل الأنشطة',
    color: '#8B5CF6',
    bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
    borderColor: 'rgba(139, 92, 246, 0.5)',
    onClick: () => setActiveTab('audit')
  },
  {
    id: 'backup',
    icon: 'Database',
    label: 'النسخ الاحتياطية',
    color: '#06B6D4',
    bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
    borderColor: 'rgba(6, 182, 212, 0.5)',
    onClick: () => setActiveTab('backup')
  },
  {
    id: 'performance',
    icon: 'Activity',
    label: 'الأداء',
    color: '#EC4899',
    bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 114, 182, 0.25) 100%)',
    borderColor: 'rgba(236, 72, 153, 0.5)',
    onClick: () => setActiveTab('performance')
  }];


  const mockUsers = [];

  const mockRoles = [];

  const mockPermissions = [];

  const mockRolePermissions = {};

  const mockSystemConfig = {
    systemName: "",
    systemEmail: "",
    systemPhone: "",
    maintenanceMode: false,
    defaultLanguage: "ar",
    defaultCurrency: "JOD",
    dateFormat: "DD/MM/YYYY",
    useArabicNumerals: true,
    googleMapsApiKey: "",
    googleMapsEnabled: false,
    whatsappPhone: "",
    whatsappToken: "",
    whatsappEnabled: false,
    chatgptApiKey: "",
    chatgptEnabled: false,
    sessionTimeout: 30,
    maxLoginAttempts: 5,
    twoFactorAuth: false,
    auditLogging: true,
    dataEncryption: true
  };

  const mockAuditLogs = [];

  const mockSecurityStats = {
    failedLogins: 0,
    failedLoginsTrend: 0,
    activeSessions: 0,
    activeSessionsTrend: 0,
    suspiciousActivities: 0,
    suspiciousActivitiesTrend: 0,
    blockedAccounts: 0,
    blockedAccountsTrend: 0
  };

  const mockRecentAlerts = [];

  const mockBackups = [];

  const mockPerformanceData = {
    responseTime: [],
    concurrentUsers: [],
    avgLoadTime: 0,
    successRate: 0,
    uptime: 0,
    errorRate: 0
  };

  const mockSystemResources = {
    cpuUsage: 0,
    memoryUsage: 0,
    diskUsage: 0,
    networkUsage: 0
  };

  // Load users from Supabase
  useEffect(() => {
    if (activeTab === 'users') {
      loadUsers();
    }
  }, [activeTab]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase?.from('user_profiles')?.select('*')?.order('created_at', { ascending: false });

      if (error) throw error;
      setUsers(data || []);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setShowUserModal(true);
  };

  const handleAddUser = () => {
    setEditingUser(null);
    setShowUserModal(true);
  };

  const handleSaveUser = async (userData) => {
    try {
      if (editingUser) {
        // Update existing user
        const { error } = await supabase?.from('user_profiles')?.update({
            full_name: userData?.fullName,
            email: userData?.email,
            phone: userData?.phone,
            role: userData?.role,
            is_active: userData?.isActive
          })?.eq('id', editingUser?.id);

        if (error) throw error;
      } else {
        // Create new user - Note: This requires auth.admin API or backend function
        // For now, we'll just insert into user_profiles
        const { error } = await supabase?.from('user_profiles')?.insert({
            full_name: userData?.fullName,
            email: userData?.email,
            phone: userData?.phone,
            role: userData?.role,
            is_active: true
          });

        if (error) throw error;
      }

      await loadUsers();
      setShowUserModal(false);
      setEditingUser(null);
    } catch (error) {
      console.error('Error saving user:', error);
      alert('فشل في حفظ المستخدم: ' + error?.message);
    }
  };

  const handleToggleStatus = async (userId, currentStatus) => {
    try {
      const { error } = await supabase?.from('user_profiles')?.update({ is_active: !currentStatus })?.eq('id', userId);

      if (error) throw error;
      await loadUsers();
    } catch (error) {
      console.error('Error toggling user status:', error);
    }
  };

  const handleBulkAction = (action, userIds) => {
    console.log('Bulk action:', action, userIds);
  };

  const handleUpdatePermissions = (permissions) => {
    console.log('Updating permissions:', permissions);
  };

  const handleSaveConfig = (config) => {
    console.log('Saving config:', config);
  };

  const handleExportAuditLog = () => {
    console.log('Exporting audit log');
  };

  const handleViewSecurityDetails = () => {
    console.log('Viewing security details');
  };

  const handleCreateBackup = (type) => {
    console.log('Creating backup:', type);
  };

  const handleRestoreBackup = (backupId) => {
    console.log('Restoring backup:', backupId);
  };

  const handleDeleteBackup = (backupId) => {
    console.log('Deleting backup:', backupId);
  };

  const quickActions = [
  {
    label: 'إضافة مستخدم جديد',
    icon: 'UserPlus',
    onClick: () => handleAddUser(),
    roles: ['admin'],
    variant: 'primary'
  },
  {
    label: 'تصدير سجل الأنشطة',
    icon: 'Download',
    onClick: handleExportAuditLog,
    roles: ['admin'],
    variant: 'default'
  },
  {
    label: 'إنشاء نسخة احتياطية',
    icon: 'Database',
    onClick: () => handleCreateBackup('full'),
    roles: ['admin'],
    variant: 'default'
  }];


  const actionBoxesConfig = [
  {
    id: 'add-user',
    icon: 'UserPlus',
    label: 'إضافة مستخدم',
    color: '#3B82F6',
    bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
    borderColor: 'rgba(59, 130, 246, 0.5)',
    onClick: () => handleAddUser()
  },
  {
    id: 'system-config',
    icon: 'Settings',
    label: 'إعدادات النظام',
    color: '#6366F1',
    bgGradient: 'linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(129, 140, 248, 0.25) 100%)',
    borderColor: 'rgba(99, 102, 241, 0.5)',
    onClick: () => setActiveTab('config')
  },
  {
    id: 'backup',
    icon: 'Database',
    label: 'نسخ احتياطي',
    color: '#10B981',
    bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
    borderColor: 'rgba(16, 185, 129, 0.5)',
    onClick: () => setActiveTab('backup')
  }];


  return (
    <Layout
      userRole={currentUser?.role}
      userName={currentUser?.name}
      onQuickMenuToggle={handleQuickMenuToggle}>

      <SubHeader pageTitle="إدارة النظام" />

      <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">
        <div className="space-y-4 md:space-y-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mt-4">
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-[var(--color-foreground)]">
                إدارة النظام والمستخدمين
              </h1>
              <p className="text-sm md:text-base text-[var(--color-muted-foreground)] mt-2">
                مركز التحكم الإداري لإدارة المستخدمين والصلاحيات وإعدادات النظام
              </p>
            </div>
            <div className="flex items-center gap-3">
              <Button variant="outline" iconName="RefreshCw" onClick={() => window.location?.reload()}>
                تحديث
              </Button>
              <Button variant="default" iconName="Settings">
                الإعدادات المتقدمة
              </Button>
            </div>
          </div>
        </div>

        <QuickActionToolbar actions={quickActions} userRole={currentUser?.role} />

        <div className="bg-[var(--color-card)] rounded-lg border border-[var(--color-border)] shadow-warm overflow-hidden">
          <div className="border-b border-[var(--color-border)] overflow-x-auto">
            <div className="flex items-center gap-2 p-2 min-w-max">
              {adminActions?.map((action) =>
              <button
                key={action?.id}
                onClick={() => setActiveTab(action?.id)}
                className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
                activeTab === action?.id ?
                'bg-[var(--color-primary)] text-white shadow-warm' :
                'text-[var(--color-foreground)] hover:bg-[var(--color-muted)]'}`
                }>

                  <Icon name={action?.icon} size={18} />
                  <span>{action?.label}</span>
                </button>
              )}
            </div>
          </div>

          <div className="p-4 md:p-6">
            {activeTab === 'approvals' &&
              <UserApprovalPanel />
            }

            {activeTab === 'users' &&
              <UserManagementGrid
                users={loading ? mockUsers : users}
                currentUserRole={currentUser?.role}
                onEditUser={handleEditUser}
                onToggleStatus={handleToggleStatus}
                onBulkAction={handleBulkAction} />
            }

            {activeTab === 'permissions' &&
            <RolePermissionMatrix
              roles={mockRoles}
              permissions={mockPermissions}
              rolePermissions={mockRolePermissions}
              currentUserRole={currentUser?.role}
              onUpdatePermissions={handleUpdatePermissions} />

            }

            {activeTab === 'config' &&
            <SystemConfigurationPanel
              config={mockSystemConfig}
              onSaveConfig={handleSaveConfig} />

            }

            {activeTab === 'security' &&
            <SecurityMonitoringDashboard
              securityStats={mockSecurityStats}
              recentAlerts={mockRecentAlerts}
              onViewDetails={handleViewSecurityDetails} />

            }

            {activeTab === 'audit' &&
            <AuditTrailViewer
              auditLogs={mockAuditLogs}
              onExport={handleExportAuditLog} />

            }

            {activeTab === 'backup' &&
            <BackupManagementPanel
              backups={mockBackups}
              onCreateBackup={handleCreateBackup}
              onRestoreBackup={handleRestoreBackup}
              onDeleteBackup={handleDeleteBackup} />

            }

            {activeTab === 'performance' &&
            <PerformanceMonitoringPanel
              performanceData={mockPerformanceData}
              systemResources={mockSystemResources} />

            }
          </div>
        </div>
      </div>

      {/* User Edit Modal */}
      <UserEditModal
        isOpen={showUserModal}
        onClose={() => {
          setShowUserModal(false);
          setEditingUser(null);
        }}
        onSave={handleSaveUser}
        user={editingUser}
      />
    </Layout>);

};

export default SystemAdministrationAndUserManagement;